module.exports = __webpack_public_path__ + "img/1bn.a446565a.jpg";